import { __rest } from 'tslib';
import React from 'react';
import { space } from 'styled-system';
import { styled, Currency, SvgIcon } from '@teko/ui';

const Wrapper = styled.div(space, ({ theme }) => `
  display: flex;
  justify-content: space-between;
  --button-icon-color: ${theme.colors.green400};
  `);
const PriceWrapper = styled.div `
  display: flex;
  flex-direction: ${(props) => props.horizontal ? '' : 'column'};
  align-items: baseline;
`;
const Price = styled(Currency)((props) => `
  margin-bottom: ${props.size === 'lg' ? '0.5rem' : '0'};
  font-size: ${props.size === 'md' ? '1rem' : '1.75rem'};
  font-weight: 500;
  color: ${props.theme.brand.primary};
  font-weight: bold;
`);
const DiscountWrapper = styled.div `
  display: flex;
  align-items: center;
  width: 100%;
`;
const ListedPrice = styled(Currency)(({ lineThrough, theme, size, horizontal }) => `
  text-decoration: ${lineThrough ? 'line-through' : 'none'};
  color: ${theme.colors.gray130};
  font-size: ${size === 'md' ? '0.75rem' : '1.25rem'};
  margin-left: ${horizontal ? '6px' : ''};
`);
const Discount = styled.span(({ theme }) => `
  font-size: 0.75rem;
  color: ${theme.brand.secondary};
  margin-left: 6px;
`);
const EditIcon = styled(SvgIcon)(({ theme: { colors } }) => `
    width: 1.25rem;
    height: 1.25rem;
    margin-left: 0.25rem;
    background-color: ${colors.link500};
  `);
const PriceEditIcon = styled.div `
  display: flex;
  flex-direction: row;
`;
const ProductPrice = (_a) => {
    var { price, discount, horizontal = false, size = 'md', className, unitPrice, listedPrice, consultationServiceFee = 0, isPriceEditable = false, onEditPrice } = _a, props = __rest(_a, ["price", "discount", "horizontal", "size", "className", "unitPrice", "listedPrice", "consultationServiceFee", "isPriceEditable", "onEditPrice"]);
    return (React.createElement(Wrapper, Object.assign({}, props, { className: className }),
        React.createElement(PriceWrapper, { horizontal: horizontal },
            price !== null && price !== undefined && (React.createElement(PriceEditIcon, null,
                React.createElement(Price, { className: "price", size: size, value: price }),
                isPriceEditable && React.createElement(EditIcon, { name: "edit", onClick: onEditPrice }))),
            React.createElement(DiscountWrapper, null,
                unitPrice && unitPrice !== price - consultationServiceFee && (React.createElement(ListedPrice, { className: "listed-price", horizontal: horizontal, size: size, value: unitPrice, lineThrough: true })),
                listedPrice && listedPrice !== price && (React.createElement(ListedPrice, { className: "listed-price", horizontal: horizontal, size: size, value: listedPrice, lineThrough: listedPrice && listedPrice !== price })),
                !!discount && React.createElement(Discount, null, discount)))));
};

export { ProductPrice as P };
